module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag09_0371AT.fe0cf7c0.jpg";